export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/NYT.e1bdbaf7.svg","height":29,"width":212};